import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full space-y-4" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "text-gray-300" }, " Action "),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Swap")
  ])
], -1)
const _hoisted_5 = { class: "flex flex-col items-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-300" }, " Value ", -1)
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-300" }, " Details ", -1)
const _hoisted_10 = { class: "px-6 py-4 flex -mt-1 items-center flex-wrap" }
const _hoisted_11 = { class: "token-item" }
const _hoisted_12 = { class: "font-numeric" }
const _hoisted_13 = { class: "token-item" }
const _hoisted_14 = { class: "font-numeric" }
const _hoisted_15 = { class: "flex flex-col items-end" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-300" }, " Time ", -1)
const _hoisted_17 = { class: "flex items-center justify-end wrap whitespace-nowrap text-right" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-300 text-center py-8" }, " You haven't made any stakes in this pool ", -1)

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatDistanceToNow } from 'date-fns';

import useTokens from '@/composables/useTokens';
import useNumbers from '@/composables/useNumbers';

import { PoolSwap } from '@/services/balancer/subgraph/types';

import { bnum } from '@/lib/utils';
import useWeb3 from '@/services/web3/useWeb3';

/**
 * TYPES
 */
type SwapRow = {
  tokenIn: string;
  tokenOut: string;
  tokenAmountIn: string;
  tokenAmountOut: string;
  timestamp: number;
  formattedDate: string;
  value: number;
  formattedValue: string;
  tx: string;
};

type Props = {
  tokens: string[];
  poolSwaps: PoolSwap[];
  isLoading?: boolean;
  isLoadingMore?: boolean;
  loadMore?: () => void;
  isPaginated?: boolean;
  noResultsLabel?: string;
};

/**
 * PROPS & EMITS
 */

export default _defineComponent({
  props: {
    tokens: { type: Array, required: true },
    poolSwaps: { type: Array, required: true },
    isLoading: { type: Boolean, required: false, default: false },
    isLoadingMore: { type: Boolean, required: false, default: false },
    loadMore: { type: Function, required: false },
    isPaginated: { type: Boolean, required: false, default: false },
    noResultsLabel: { type: String, required: false }
  } as unknown as undefined,
  emits: ['loadMore'],
  setup(__props: {
  tokens: string[];
  poolSwaps: PoolSwap[];
  isLoading?: boolean;
  isLoadingMore?: boolean;
  loadMore?: () => void;
  isPaginated?: boolean;
  noResultsLabel?: string;
}, { emit }) {

const props = __props




/**
 * COMPOSABLES
 */
const { fNum } = useNumbers();
const { t } = useI18n();
const { priceFor } = useTokens();
const { explorerLinks } = useWeb3();

const swapRows = computed<SwapRow[]>(() =>
  props.isLoading
    ? []
    : props.poolSwaps.map(({ tokenIn, tokenOut, tokenAmountIn, tokenAmountOut, timestamp, tx }) => {
        const value = bnum(priceFor(tokenOut))
          .times(tokenAmountOut)
          .toNumber();

        return {
          value,
          formattedValue: value > 0 ? fNum(fNum(value, 'usd'), 'usd_m') : '-',
          tokenIn,
          tokenOut,
          tokenAmountIn,
          tokenAmountOut,
          timestamp,
          formattedDate: t('timeAgo', [formatDistanceToNow(timestamp)]),
          tx
        };
      })
);

return (_ctx: any,_cache: any) => {
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(swapRows), (action, index) => {
      return (_openBlock(), _createBlock(_component_BalCard, { key: index }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(action.formattedValue), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_BalAsset, {
                      address: action.tokenIn,
                      class: "mr-2 flex-shrink-0"
                    }, null, 8, ["address"]),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(fNum)(action.tokenAmountIn, 'token')), 1)
                  ]),
                  _createVNode(_component_BalIcon, {
                    name: "arrow-right",
                    class: "mx-1"
                  }),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_BalAsset, {
                      address: action.tokenOut,
                      class: "mr-2 flex-shrink-0"
                    }, null, 8, ["address"]),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(fNum)(action.tokenAmountOut, 'token')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createTextVNode(_toDisplayString(action.formattedDate) + " ", 1),
                  _createVNode(_component_BalLink, {
                    href: _unref(explorerLinks).txLink(action.tx),
                    external: "",
                    class: "ml-2 flex items-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BalIcon, {
                        name: "arrow-up-right",
                        size: "sm",
                        class: "text-gray-200 hover:text-white transition-colors"
                      })
                    ]),
                    _: 2
                  }, 1032, ["href"])
                ])
              ])
            ])
          ])
        ]),
        _: 2
      }, 1024))
    }), 128)),
    (_unref(swapRows).length === 0)
      ? (_openBlock(), _createBlock(_component_BalCard, { key: 0 }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.isPaginated && !__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "bal-table-pagination-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (!__props.isLoadingMore && emit('loadMore')))
        }, [
          (__props.isLoadingMore)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$t('loading')), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.$t('loadMore')) + " ", 1),
                _createVNode(_component_BalIcon, {
                  name: "chevron-down",
                  size: "sm",
                  class: "ml-2"
                })
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})